import { Link } from "@tanstack/react-router";
import type { BlogPost } from "@/lib/blog.functions";

function formatDate(s: string | null) {
  if (!s) return "";
  return new Date(s).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export function BlogPostCard({ post }: { post: BlogPost }) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-xl border border-border bg-white transition-shadow hover:shadow-lg">
      <Link to={post.path} className="block aspect-[16/10] overflow-hidden bg-[var(--surface)]">
        {post.featured_image_url ? (
          <img
            src={post.featured_image_url}
            alt={post.featured_image_alt ?? post.title}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
          />
        ) : (
          <div className="h-full w-full bg-gradient-to-br from-primary/10 to-accent/10" />
        )}
      </Link>
      <div className="flex flex-1 flex-col p-5">
        {post.category_name && (
          <span className="mb-2 inline-block w-fit rounded-full bg-accent/15 px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-accent">
            {post.category_name}
          </span>
        )}
        <h2 className="text-xl font-semibold leading-snug text-primary">
          <Link to={post.path} className="hover:text-accent">
            {post.title}
          </Link>
        </h2>
        {post.excerpt && (
          <p className="mt-2 line-clamp-2 text-sm text-[var(--muted-foreground)]">
            {post.excerpt}
          </p>
        )}
        <div className="mt-4 flex items-center justify-between border-t border-border pt-3 text-xs text-[var(--muted-foreground)]">
          <span>
            {formatDate(post.published_at)} · {post.read_time_minutes} min read
          </span>
          <Link to={post.path} className="font-semibold text-accent hover:underline">
            Read more →
          </Link>
        </div>
      </div>
    </article>
  );
}
